import React from 'react';
import ExperienceRiskBadge from './ExperienceRiskBadge';

const ComplaintRiskPanel = ({ records = [] }) => {
  const rows = [...records]
    .sort((a, b) => String(b.complaintRiskLevel || '').localeCompare(String(a.complaintRiskLevel || '')))
    .slice(0, 8);

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Risiko Komplain</h3>
      <div className="mt-3 space-y-2">
        {rows.map((item) => (
          <div key={`complaint-${item.customerId}`} className="rounded-lg border border-slate-800 bg-slate-950/60 p-2.5 text-xs text-slate-300">
            <div className="flex items-center justify-between">
              <div className="font-medium text-slate-100">{item.customerId}</div>
              <ExperienceRiskBadge level={item.complaintRiskLevel} />
            </div>
            <div className="mt-1 text-slate-400">{item.primaryIssueType}</div>
            <div className="mt-1 text-slate-400">{item.recommendedAction}</div>
          </div>
        ))}
        {!rows.length ? <div className="text-xs text-slate-500">Tidak ada risiko komplain tinggi.</div> : null}
      </div>
    </section>
  );
};

export default ComplaintRiskPanel;
